import { makeStyles } from 'tss-react/mui';

const useStylesChartGantt: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  containerChart: {
    overflow: 'hidden',
    borderBottom: `1px solid ${theme.palette.info.main}`,
    '& > div': {
      width: 'calc(100% - 1px) !important',
      height: 'calc(100vh - 240px) !important',
    },
  },
  containerChartView: {
    '& .gantt_add, & .gantt_grid_head_add': {
      display: 'none',
    },
    '& .gantt_task_link:hover .gantt_line_wrapper div': {
      boxShadow: 'none !important',
    },
    '& .gantt_task_content, & .gantt_link_arrow, & .gantt_task_link .gantt_line_wrapper': {
      cursor: 'default',
    },
    '& .gantt_link_target .gantt_link_control div, & .gantt_task_line.gantt_drag_move .gantt_link_control div': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_drag_move .gantt_task_drag': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_drag_move .gantt_task_progress_drag': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_drag_progress .gantt_link_control div, & .gantt_task_progress_drag': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_drag_progress .gantt_task_drag, & .gantt_task_line.gantt_drag_progress': {
      display: 'none',
    },
    '& .gantt_task_progress_drag, & .gantt_task_line.gantt_drag_resize .gantt_link_control div': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_drag_resize .gantt_task_drag, & .gantt_task_line.gantt_drag_resize': {
      display: 'none',
    },
    '& .gantt_task_progress_drag, & .gantt_task_line.gantt_selected .gantt_link_control div': {
      display: 'none',
    },
    '& .gantt_task_line.gantt_selected .gantt_task_drag, & .gantt_task_line.gantt_selected .gantt_task_progress_drag': {
      display: 'none',
    },
  },
}));

export default useStylesChartGantt;
